import { render } from "./ModalHorario.vue?vue&type=template&id=66b64412&scoped=true"
import script from "./ModalHorario.vue?vue&type=script&lang=js"
export * from "./ModalHorario.vue?vue&type=script&lang=js"

import "./ModalHorario.vue?vue&type=style&index=0&id=66b64412&scoped=true&lang=css"

import exportComponent from "C:\\Users\\vinicius.martins\\Desktop\\pasta\\teste\\projeto-automacao\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66b64412"]])

export default __exports__